import script from "./MyBenefit.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBenefit.vue?vue&type=script&setup=true&lang=js"

import "./MyBenefit.vue?vue&type=style&index=0&id=bef4ea46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bef4ea46"]])

export default __exports__